<template>
  <v-dialog v-model="modalComputed" persistent scrollable max-width="800" v-if="filialComputed !== undefined">
      <v-card>

          <v-toolbar flat color="accent">
            <v-btn icon @click="modalComputed = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Replicação de dados entre Empresas</v-toolbar-title>
          </v-toolbar>

          <v-card-text class="ma-0 pa-0">
            <v-container>
              <v-row>
                <v-col>
                  <v-container fluid v-if="replicadas > 0 && replicadas === destinoSelecionadas.length">
                    <v-row>
                      <v-col class="d-flex justify-center">
                        <v-icon size="45" color="primary">mdi-check</v-icon><br />Replicação de dados realizada com sucesso!
                      </v-col>
                    </v-row>
                  </v-container>
                  <v-container v-else>
                    <v-row>
                      <v-col>
                        Replicar os dados da filial de origem para as filiais de destino. Os dados replicados são: Empregados, Finalizadoras, Prazos, Planos, Produtos, Preços, EANs, Parametros, Tabela IBPT e Recursos Externos.<br />
                        <br />Empresa de Origem: <v-chip class="primary">{{ filialComputed.cc_fil }}</v-chip>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="d-flex flex-column">
                        <v-card outlined>
                          <v-card-text>
                            <v-select
                              v-model="destinoSelecionadas"
                              :items="destino"
                              item-value="cc_fil"
                              item-text="cc_fil"
                              label="Empresas de Destino"
                              multiple
                              chips
                              persistent-hint
                              :disabled="iniciada"
                            ></v-select>
                            <v-btn depressed outlined color="primary" @click="iniciarReplicacao()" :disabled="iniciada || destinoSelecionadas.length === 0">
                                REPLICAR
                            </v-btn>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {

  name: 'Replica',

  data() {
    return {

      id: 0,
      replicado: {},
      destino: [],
      destinoSelecionadas: [],
      replicadas: 0,
      iniciada: false,

      modalTemp : false,
      filialTemp: undefined
    }

  },

  props: {

    filial: {
      required: true
    },

    modal: {
      required: true,
      type: Boolean
    },

  },

  methods: {

    populaFiliais() { 
      if(this.filialComputed !== undefined) {
        this.$store.dispatch('pesquisarFilial', {size:9999}).then(resp => {
          resp.data.content.forEach(el => {
            if(el.cc_fil != this.filialComputed.cc_fil)
            this.destino.push(el)
          });
        }).catch()
      }
    },

    iniciarReplicacao() {
      this.iniciada = true
      this.destinoSelecionadas.forEach((e) => {
        let dados = {
          cc_fil_o: this.filialComputed.cc_fil,
          cc_fil_d:e,
          bl_emp: true,
          bl_fin: true,
          bl_prz: true,
          bl_pla: true,
          bl_psr: true,
          bl_par: true,
          bl_ibp: true,
          bl_rec: true
        }

        this.$store.dispatch('replicarFilial', dados).then(() => {
          this.replicadas++
        }).catch((err) => { console.log('>> repliacao >>', err) })

      })

    },
  },

  computed: {
    modalComputed :  {
      get: function() { 
        return this.modalTemp
      },
      set: function(value) {
        this.modalTemp = value
      }
    },
    filialComputed: {
      get: function() { 
        return this.filialTemp
      },
      set: function(value) {
        this.filialTemp = value
      }
    }
  },

  mounted: function() {
    this.populaFiliais()
  },

  created: function() {
    
    this.modalComputed = this.modal
    this.filialComputed = this.filial
    this.$emit('a')

  }

}
</script>